/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoicestatusvoid2Inputs */

const en_invoicestatusvoid2 = /** @type {(inputs: Invoicestatusvoid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canceled`)
};

const de_invoicestatusvoid2 = /** @type {(inputs: Invoicestatusvoid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storniert`)
};

/**
* | output |
* | --- |
* | "Canceled" |
*
* @param {Invoicestatusvoid2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const invoicestatusvoid2 = /** @type {((inputs?: Invoicestatusvoid2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoicestatusvoid2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invoicestatusvoid2(inputs)
	return de_invoicestatusvoid2(inputs)
});
export { invoicestatusvoid2 as "invoiceStatusVoid" }